package uk.co.nickthecoder.kyd

/**
 * An [ActResource] is part of the [Game]'s [Resource] tree,
 * whereas an [Act] is NOT a [Resource] and is therefore NOT in the [Resource] tree.
 */
class ActResource(
    parent: ParentResource,
    name: String,
) : AbstractParentResource(parent, name), FileResource {

    override val resourceType: ResourceType
        get() = ResourceType.ACT

    override val filename: String
        get() = "$name.act"

    /**
     * Paths to other [ActResource]s which are combined with this act.
     */
    val includeActPaths = mutableListOf<String>()

}
